export function getPasswordTwoFactorKey(userId: number): string {
  return `project_analysis_password_2fa_required_${userId}`;
}

export function isPasswordTwoFactorRequired(userId: number): boolean {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem(getPasswordTwoFactorKey(userId)) === '1';
}

export function setPasswordTwoFactorRequired(userId: number, required: boolean): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(getPasswordTwoFactorKey(userId), required ? '1' : '0');
}
